import $ from 'jquery';

function handleerror(xhr, status, error) {
  console.log("Ajax Failure");
  console.log(xhr.responseText);
  console.log(status);
  console.log(error);
}

function ajaxWrapper(type, url, data, returnFunc, failFunc){
    if (type === "POST") {
        data["csrfmiddlewaretoken"] = window.secretReactVars["csrfmiddlewaretoken"];
    }

    let auth_token = '';
    let beforeSend = null;

    if (localStorage.getItem('token')) {
        auth_token = 'Bearer ' + localStorage.getItem('token');
        beforeSend = function(request) {
            request.setRequestHeader('Authorization', auth_token);
        };
    }

    return $.ajax({
        type: type,
        url: url,
        beforeSend: beforeSend,
        data: data,
        statusCode: {

            // ✅ FIXED
            200: function (value) {
                if (typeof value === "object" && "redirect" in value) {
                    window.location =
                        value.redirect + "?redirect=" + window.secretReactVars.BASE_URL;
                    return;
                }

                if (typeof returnFunc === "function") {
                    returnFunc(value);
                } else {
                    console.warn(
                        "ajaxWrapper: returnFunc is not a function",
                        returnFunc
                    );
                }
            },

            400: function (value) {
                value = { error: "Bad Request" };
                if (typeof returnFunc === "function") {
                    returnFunc(value);
                }
            },

            401: function () {
                refreshToken(type, url, data, returnFunc);
            },

            404: function (xhr) {
                if (typeof failFunc === "function") {
                    failFunc(xhr);
                } else {
                    console.log("Error, 404");
                }
            },
        },
    });
}

function refreshToken(type, url, data, returnFunc){
    let refreshData = {};
    refreshData["csrfmiddlewaretoken"] = window.secretReactVars["csrfmiddlewaretoken"];

    if (localStorage.getItem('refresh_token')) {
        refreshData['refresh'] = localStorage.getItem('refresh_token');
    }

    $.ajax({
        type: 'POST',
        url: '/users/token/refresh/',
        data: refreshData,
        statusCode: {
            401: function () {
                console.log('Refresh Token Expired');
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                window.location.href = '/login/';
            }
        },
        success: function (value) {
            localStorage.setItem('token', value.access);
            ajaxWrapper(type, url, data, returnFunc);
        },
        error: function (xhr, status, error) {
            handleerror(xhr, status, error);
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/login/';
        }
    });
}

export default ajaxWrapper;
